import { Modal, Radio } from "antd";
import Buttons from "../../../../base/basicComponents/button/index";
import BaseComponent from "../../../../base/common/BaseComponent";
import warningIcon from "../../../../assets/image/warning.png";
import styles from "./index.module.scss";
import "../tlReview.scss";
import { HeaderWithReminder } from "app/pages/procedureDetail/createProcedureDetail/utils";
import { ControlPageBehavior } from "base/basicComponents/modal/controlPageBehavior";
import ProcedureDetailService from "service/procedureFile/ProcedureDetailService";
// @ts-ignore
const controlPageBehavior = new ControlPageBehavior();

class TlReviewModal extends BaseComponent {
  componentDidUpdate(prevProps: any) {
    if (prevProps.isModalOpen !== this.props.isModalOpen) {
      if (this.props.isModalOpen) {
        const modalElement = document.querySelector('[data-target-id="tl-review-modal"]');
        controlPageBehavior.addEleListener(modalElement);
        controlPageBehavior.resetListener(modalElement, () => {
          const para = {
            procedureId: this.props.procedureId,
            procedureSectionType: "TLReview",
            setLock: false,
          };
          ProcedureDetailService.setSectionLock(
            para,
            () => {
              window.location.reload();
            },
            (response: any) => {
              //empty function
            }
          );
        });
      } else {
        controlPageBehavior.clearListener();
      }
    }
  }
  render() {
    const { isModalOpen, onSubmit, onCancel, showMessage, radioValue, submitDisabled, zIndex } =
      this.props;

    const footer = (
      <div className={styles.buttonDiv}>
        <Buttons color="grey" size="middle" onClick={onCancel} testid="tl-review-cancel-btn">
          Cancel
        </Buttons>
        <Buttons
          color="blue"
          disabled={submitDisabled}
          size="middle"
          onClick={() => onSubmit(radioValue)}
          testid="tl-review-submit-btn"
        >
          Submit
        </Buttons>
      </div>
    );

    return (
      <Modal
        title={<HeaderWithReminder>TL Review Procedure</HeaderWithReminder>}
        centered
        open={isModalOpen}
        footer={footer}
        closable={false}
        width="47rem"
        className="tlReviewModal"
        data-target-id="tl-review-modal"
        data-testid="tl-review-modal"
        onCancel={onCancel}
        zIndex={zIndex}
        maskClosable={false}
      >
        <div className={styles.tlReviewModalContent}>
          {showMessage && (
            <div className={styles.tlReviewModalMessageDiv}>
              <img src={warningIcon} alt="" className={styles.tlReviewModalMessageIcon} />
              <p className={styles.tlReviewModalMessage}>
                There is a TL Review Procedure process going on, you can initiate a new process if
                it is needed.
              </p>
            </div>
          )}
          <Radio.Group
            onChange={this.props.radioOnChange}
            value={radioValue}
            data-testid="tl-review-modal-radio-group"
          >
            <Radio value={1} data-testid="tl-review-modal-radio-todo">
              Create a Review Procedure to-do
            </Radio>
            <Radio value={2} data-testid="tl-review-modal-radio-enter-results">
              Enter Review Results
            </Radio>
          </Radio.Group>
        </div>
      </Modal>
    );
  }
}

export default TlReviewModal;
